import { Input } from '@workspace/ui/components/input';
import { Label } from '@workspace/ui/components/label';
import { cn } from '@workspace/ui/lib/utils';
import type { ChangeEvent } from 'react';

interface FormFieldProps {
  label: string;
  name: string;
  id?: string;
  placeholder?: string;
  value: string;
  error?: string;
  onInput: (e: ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  type?: string;
}

export const FormField = ({
  label,
  name,
  id,
  placeholder,
  value,
  error,
  onInput,
  required = true,
  type = 'text',
}: FormFieldProps) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label
          htmlFor={id || name}
          className="text-sm font-medium text-primary-700"
        >
          {label}
          {required && <span className="text-red-500">*</span>}
        </Label>
      </div>
      <Input
        id={id || name}
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        onInput={onInput}
        className={cn('w-full', {
          'border-red-500 ring-1 ring-red-500': !!error,
        })}
        autoComplete="on"
      />
      {error && <p className="text-destructive font-normal text-sm">{error}</p>}
    </div>
  );
};
